import { render } from "./ProsesPotensi.vue?vue&type=template&id=1235d2d3"
import script from "./ProsesPotensi.vue?vue&type=script&lang=js"
export * from "./ProsesPotensi.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__